const ACTION_TYPES = {
    RESET_UI_STATE: 'RESET_UI_STATE',
    ROUTER_NAVIGATION: 'ROUTER_NAVIGATION',
    SELECT_PORTFOLIOS: 'SELECT_PORTFOLIOS',
    SELECT_ITEMS: 'SELECT_ITEMS',
    SET_CREATE_FOLDER_ON_LOAD: 'SET_CREATE_FOLDER_ON_LOAD',
    SET_CURRENCY: 'SET_CURRENCY',
    SET_EDIT_MODE: 'SET_EDIT_MODE',
    SET_FAVORITE_ITEM_ON_LOAD: 'SET_FAVORITE_ITEM_ON_LOAD',
    SET_FULL_PAGE_LOADING: 'SET_FULL_PAGE_LOADING',
    SET_PARTIAL_PAGE_LOADING: 'SET_PARTIAL_PAGE_LOADING',
    SET_MUTATION_RESPONSE: 'SET_MUTATION_RESPONSE',
    SET_NUM_ITEMS: 'SET_NUM_ITEMS',
    SET_PORTFOLIO_IDS: 'SET_PORTFOLIO_IDS',
    SET_PORTFOLIO_NAME: 'SET_PORTFOLIO_NAME',
    SET_PORTFOLIO_TYPES: 'SET_PORTFOLIO_TYPES',
    SET_PORTFOLIO_VIEW_PERMISSION: 'SET_PORTFOLIO_VIEW_PERMISSION',
    SET_PROJECT_ID: 'SET_PROJECT_ID',
    SET_REORDERED: 'SET_REORDERED',
    SET_REORDER_MODE: 'SET_REORDER_MODE',
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    SET_SELECT_ALL: 'SET_SELECT_ALL',
    SET_SELECT_MODE: 'SET_SELECT_MODE',
    SET_SORT_BY: 'SET_SORT_BY',
    SET_STICK_TOOLBAR: 'SET_STICK_TOOLBAR',
    SET_TAB: 'SET_TAB',
    SET_TAB_CHANGED: 'SET_TAB_CHANGED',
    SET_TOTAL_RESULTS: 'SET_TOTAL_RESULTS',
    SET_SHOULD_TRACK_REORDERING: 'SET_SHOULD_TRACK_REORDERING',
    SET_USER_HAS_CHANGED: 'SET_USER_HAS_CHANGED',
    SET_VIEWING_PUBLIC_VERSION: 'SET_VIEWING_PUBLIC_VERSION',
    STICK_TOOLBAR: 'STICK_TOOLBAR',
    SLIDE_NAV_BORDER: 'SLIDE_NAV_BORDER',
    SET_VIEW_MODE: 'SET_VIEW_MODE',
    SET_AUTH_MODAL_STATE: 'SET_AUTH_MODAL_STATE',
    SET_PAGE: 'SET_PAGE',
};

function resetUiState({ retainItems = false, retainSort = false, retainSearch = false } = {}) {
    return { type: ACTION_TYPES.RESET_UI_STATE, retainItems, retainSort, retainSearch };
}

function routerNavigation(input) {
    return { type: ACTION_TYPES.ROUTER_NAVIGATION, routerNavigation: input.routerNavigation };
}

function selectPortfolios({ selectedPortfolios }) {
    return { type: ACTION_TYPES.SELECT_PORTFOLIOS, selectedPortfolios };
}

function selectItems({ selectedItems }) {
    return { type: ACTION_TYPES.SELECT_ITEMS, selectedItems };
}

function setCreateFolderOnLoad({ createFolderOnLoad }) {
    return { type: ACTION_TYPES.SET_CREATE_FOLDER_ON_LOAD, createFolderOnLoad };
}

function setCurrency({ currency }) {
    return { type: ACTION_TYPES.SET_CURRENCY, currency };
}

function setEditMode({ editing }) {
    return { type: ACTION_TYPES.SET_EDIT_MODE, editing };
}

function setFavoriteItemOnLoad({ favoriteItemOnLoad }) {
    return { type: ACTION_TYPES.SET_FAVORITE_ITEM_ON_LOAD, favoriteItemOnLoad };
}

function setFullPageLoading({ isLoadingFullPage }) {
    return { type: ACTION_TYPES.SET_FULL_PAGE_LOADING, isLoadingFullPage };
}

function setPartialPageLoading({ isLoadingPartialPage }) {
    return { type: ACTION_TYPES.SET_PARTIAL_PAGE_LOADING, isLoadingPartialPage };
}

function setMutationResponse({ mutationResponse }) {
    return { type: ACTION_TYPES.SET_MUTATION_RESPONSE, mutationResponse };
}

function setNumItems({ first }) {
    return { type: ACTION_TYPES.SET_NUM_ITEMS, first };
}

function setPortfolioIds({ portfolioIds }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_IDS, portfolioIds };
}

function setPortfolioName({ portfolioName }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_NAME, portfolioName };
}

function setPortfolioTypes({ portfolioTypes }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_TYPES, portfolioTypes };
}

function setPortfolioViewPermission({ portfolioViewPermission }) {
    return { type: ACTION_TYPES.SET_PORTFOLIO_VIEW_PERMISSION, portfolioViewPermission };
}

function setReordered({ reordered }) {
    return { type: ACTION_TYPES.SET_REORDERED, reordered };
}

function setReorderMode({ reordering }) {
    return { type: ACTION_TYPES.SET_REORDER_MODE, reordering };
}

function setSearchTerm({ searchTerm }) {
    return { type: ACTION_TYPES.SET_SEARCH_TERM, searchTerm };
}

function setSelectAll({ selectAllStatus }) {
    return { type: ACTION_TYPES.SET_SELECT_ALL, selectAllStatus };
}

function setProjectId({ projectId }) {
    return { type: ACTION_TYPES.SET_PROJECT_ID, projectId };
}

function setSelectMode({ selecting }) {
    return { type: ACTION_TYPES.SET_SELECT_MODE, selecting };
}

function setSortBy({ sortBySelection }) {
    return { type: ACTION_TYPES.SET_SORT_BY, sortBySelection };
}

function setStickToolbar({ stickToolbar }) {
    return { type: ACTION_TYPES.SET_STICK_TOOLBAR, stickToolbar };
}

function setTab({ tab }) {
    return { type: ACTION_TYPES.SET_TAB, tab };
}

function setTabChanged({ tabChanged }) {
    return { type: ACTION_TYPES.SET_TAB_CHANGED, tabChanged };
}

function setShouldTrackReordering({ shouldTrackReordering }) {
    return { type: ACTION_TYPES.SET_SHOULD_TRACK_REORDERING, shouldTrackReordering };
}

function setUserHasChanged({ userHasChanged }) {
    return { type: ACTION_TYPES.SET_USER_HAS_CHANGED, userHasChanged };
}

function slideNavBorder({ navBorder }) {
    return { type: ACTION_TYPES.SLIDE_NAV_BORDER, navBorder };
}

function setTotalResults({ totalResults }) {
    return { type: ACTION_TYPES.SET_TOTAL_RESULTS, totalResults };
}

function setViewingPublicVersion({ isPublic }) {
    return { type: ACTION_TYPES.SET_VIEWING_PUBLIC_VERSION, isPublic };
}

function setViewMode({ viewMode }) {
    return { type: ACTION_TYPES.SET_VIEW_MODE, viewMode };
}

function setAuthModalState({ authModalState }) {
    return { type: ACTION_TYPES.SET_AUTH_MODAL_STATE, authModalState };
}

function setPage({ page }) {
    return { type: ACTION_TYPES.SET_PAGE, page };
}

export default {
    ...ACTION_TYPES,
    resetUiState,
    routerNavigation,
    selectPortfolios,
    selectItems,
    setCreateFolderOnLoad,
    setCurrency,
    setEditMode,
    setFavoriteItemOnLoad,
    setFullPageLoading,
    setPartialPageLoading,
    setMutationResponse,
    setNumItems,
    setPortfolioIds,
    setPortfolioName,
    setPortfolioTypes,
    setPortfolioViewPermission,
    setReordered,
    setReorderMode,
    setSearchTerm,
    setSelectAll,
    setProjectId,
    setSelectMode,
    setSortBy,
    setStickToolbar,
    setTab,
    setTabChanged,
    setShouldTrackReordering,
    setTotalResults,
    setViewingPublicVersion,
    setUserHasChanged,
    setViewMode,
    slideNavBorder,
    setAuthModalState,
    setPage,
};
